import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { View } from 'react-native';
import { AnimatedImageView, component, H2View } from '@serviceos-rn/core';
import { TipConfig } from '../../../TipConfig';
import { NO_UNITS_URL } from '../../../Constants/Constants';
import { TipConfiguration } from '../../../Domain/DTOs/TipConfigurationDTO';
import { AvatarView } from '../../Components/Avatar/AvatarView';
export const HeaderView = component({
    provider: TipConfig.provider,
    moduleName: TipConfig.moduleName,
    componentName: TipConfiguration.ComponentNames.header,
    style(theme, mediaQuery, window, props) {
        return {
            container: {},
            row: {
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 76
            },
            title: {
                marginTop: 20,
                textAlign: 'center',
                fontWeight: '200',
                fontSize: 20,
                lineHeight: 28,
                letterSpacing: 1
            },
            layer: {},
            image: {
                height: 76
            },
            noUnitsImage: {
                height: 160,
                width: '100%'
            }
        };
    }
})(({ style, units, assets }) => {
    var _a;
    const [width, setWidth] = useState(0);
    const handleLayout = useCallback((e) => {
        setWidth(e.nativeEvent.layout.width);
    }, [width]);
    const names = units.map(unit => unit.name);
    const title = names.length <= 1
        ? names[0]
        : names.slice(0, names.length - 1).join(', ') + ` & ${names[names.length - 1]}`;
    return (_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.container, onLayout: handleLayout, children: [_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.row, children: [units.map((unit, i) => {
                        var _a;
                        return (_jsx(View, { style: [style === null || style === void 0 ? void 0 : style.layer, i > 0 && { marginLeft: -34 }], children: _jsx(AvatarView, { image: unit.image_url, imageSize: ((_a = style === null || style === void 0 ? void 0 : style.image) === null || _a === void 0 ? void 0 : _a.height) || 100 }) }, unit.id));
                    }), units.length <= 0 && (_jsx(AnimatedImageView, { image: ((_a = assets === null || assets === void 0 ? void 0 : assets.images) === null || _a === void 0 ? void 0 : _a.no_units_url) || NO_UNITS_URL, containerStyle: style === null || style === void 0 ? void 0 : style.noUnitsImage, resizeMode: "contain" }))] }), !!title && (_jsx(H2View, { textStyle: style === null || style === void 0 ? void 0 : style.title, children: title }))] }));
});
